define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports.currencyApiURL = exports.currentInvoice = exports.lastInvoice = exports.allInvoices = exports.invoicePdf = exports.warrantyPdf = exports.instructionsToActivate = exports.exportApiURL = exports.allSoldWarrantiesCount = exports.allSoldWarranties = exports.approvedWarrantiesApiURL = exports.activateWarrantyApiURL = exports.confirmDataURL = exports.deleteBuyerURL = exports.saveBuyerURL = exports.saveNoteForSellerApi = exports.sellerApiURL = exports.legalEntities = exports.deleteSeller = exports.activateSeller = exports.saveSeller = exports.damageCarApiURL = exports.damageSellerByAdminApiURL = exports.damageWarrantyApiURL = exports.damageBuyerApiURL = exports.damageSellerApiURL = exports.damageAdminApiURL = exports.damageApiURL = exports.carSellerApiURL = exports.carAdminApiURL = exports.currentUserURL = exports.adminArchiveTableDataURL = exports.adminTableDataURL = exports.warrantyDeleteApiURL = exports.warrantyEditOnlyApiURL = exports.warrantySaveOnlyApiURL = exports.warrantyEditApiURL = exports.warrantyApiURL = exports.buyerApiURL = exports.carApiURL = exports.confirmPasswordURL = exports.forgotPasswordURL = exports.registerApiURL = exports.loginApiURL = exports.statistics = exports.userApiURL = exports.baseAPI = exports.DEV_URL = exports.urlToken = void 0;
    exports.urlToken = 'https://app.g1klub.hr/';
    //export const urlToken = 'https://localhost:44353/';
    //deployment
    //export const localhostUrl = 'https://localhost:44353/';
    //export const localhostUrl = 'http://www.app-g1klub.zeraxo.com/';
    //export const DEV_URL = urlToken.indexOf('devUrlToken') >= 0 ? localhostUrl : urlToken;
    exports.DEV_URL = 'https://app.g1klub.hr/';
    //export const DEV_URL = 'https://localhost:44353/';
    exports.baseAPI = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "" + exports.DEV_URL : "" + exports.DEV_URL;
    // backend api routes
    exports.userApiURL = exports.DEV_URL + 'api/identity';
    exports.statistics = exports.DEV_URL + 'api/statistic';
    // auth routes
    exports.loginApiURL = exports.userApiURL + '/login';
    exports.registerApiURL = exports.userApiURL + '/register';
    exports.forgotPasswordURL = exports.userApiURL + "/forgotPassword";
    exports.confirmPasswordURL = exports.userApiURL + "/confirmPassword";
    exports.carApiURL = exports.DEV_URL + 'api/car';
    exports.buyerApiURL = exports.DEV_URL + 'api/buyer';
    exports.warrantyApiURL = exports.DEV_URL + 'api/warranty';
    exports.warrantyEditApiURL = exports.warrantyApiURL + '/edit';
    exports.warrantySaveOnlyApiURL = exports.warrantyApiURL + '/saveOnly';
    exports.warrantyEditOnlyApiURL = exports.warrantyApiURL + '/editOnly';
    exports.warrantyDeleteApiURL = exports.warrantyApiURL + '/delete';
    exports.adminTableDataURL = exports.DEV_URL + "api/adminWarranty";
    exports.adminArchiveTableDataURL = exports.DEV_URL + "api/adminWarranty/archive";
    exports.currentUserURL = exports.userApiURL + "/data";
    exports.carAdminApiURL = exports.DEV_URL + "api/car/admin";
    exports.carSellerApiURL = exports.DEV_URL + "api/car/seller";
    // damages
    exports.damageApiURL = exports.DEV_URL + "api/damage";
    exports.damageAdminApiURL = exports.DEV_URL + "api/damage/admin";
    exports.damageSellerApiURL = exports.DEV_URL + "api/damage/seller";
    exports.damageBuyerApiURL = exports.DEV_URL + "api/damage/buyer";
    exports.damageWarrantyApiURL = exports.DEV_URL + "api/damage/warranty";
    exports.damageSellerByAdminApiURL = exports.DEV_URL + "api/damage/sellerByAdmin";
    exports.damageCarApiURL = exports.DEV_URL + "api/damage/car";
    // seller
    exports.saveSeller = exports.DEV_URL + "api/seller/CreateUpdateSellerAsync";
    exports.activateSeller = exports.DEV_URL + "api/seller/ActivateSellerAsync";
    exports.deleteSeller = exports.DEV_URL + "api/seller/DeleteSellerAsync";
    exports.legalEntities = exports.DEV_URL + "api/seller";
    exports.sellerApiURL = exports.DEV_URL + "api/seller";
    exports.saveNoteForSellerApi = exports.DEV_URL + "api/seller/UpdateSellerNote";
    exports.submitSellerContract = exports.DEV_URL + "api/seller/SubmitSellerContract";
    exports.cancelSellerContract = exports.DEV_URL + "api/seller/CancelSellerContract";
    exports.deniedSellerContract = exports.DEV_URL + "api/seller/DeniedSellerContract";
    exports.sellerContractPdf = exports.DEV_URL + "api/seller/sellerContractPdf";
    //buyer
    exports.saveBuyerURL = exports.DEV_URL + "api/buyer/CreateUpdateBuyer";
    exports.deleteBuyerURL = exports.DEV_URL + "api/buyer/Deletebuyer";
    // confirmations
    exports.confirmDataURL = exports.userApiURL + "/confirmdata";
    exports.activateWarrantyApiURL = exports.warrantyApiURL + "/activate-warranty";
    exports.approvedWarrantiesApiURL = exports.buyerApiURL + "/approved-warranties";
    // statistics 
    exports.allSoldWarranties = exports.statistics + "/soldWarranties";
    exports.allSoldWarrantiesCount = exports.statistics + "/allSoldWarrantiesCount";
    // pdf exports
    exports.exportApiURL = 'api/export';
    exports.instructionsToActivate = exports.exportApiURL + "/uputstva-za-aktivaciju";
    exports.warrantyPdf = exports.exportApiURL + "/pravo-na-jamstvo";
    //invoicing
    // preview warranty invoice before sending
    exports.invoicePdf = "api/invoice/warranty-invoice";
    exports.allInvoices = 'api/invoice/all';
    exports.lastInvoice = 'api/invoice/last';
    exports.currentInvoice = 'api/invoice/current';
    //currency
    exports.currencyApiURL = exports.DEV_URL + 'api/currency';
});
//# sourceMappingURL=apiRoutes.js.map